module.exports = __webpack_public_path__ + "static/media/plantparent.b1d181b8.png";